"use client"

import {
    Box,
    Button,
    Container,
    Grid,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Chip,
    IconButton,
    RadioGroup,
    Radio,
    DialogContent,
    Dialog,
    Divider,
    TextField,
    Autocomplete,
    Paper,
} from "@mui/material"
import EditIcon from '@mui/icons-material/Edit';
import { Visibility, Code, Share, ContentCopy } from "@mui/icons-material"
import { useEffect, useState } from "react"
import { Images } from "../../../assests"
import OrderServices from "../../../services/OrderServices"
import { useNavigate } from "react-router-dom"
import { currencyType } from "../../../utils"
import { SecondaryButton } from "../../../components/Buttons"
import { Controller, useForm } from "react-hook-form"
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { showErrorToast } from "../../../components/Toaster";

const dummyMerchants = [
    {
        id: 1,
        name: "UrbanStitch",
        description: "UrbanStitch is your go-to destination...",
        state: "California",
        city: "Los Angeles",
        standard: {
            oneSide: "$20",
            doubleSide: "$40",
            additional: "$20",
        },
        premium: {
            oneSide: "$50",
            doubleSide: "$80",
            additional: "$20",
        },
    },
    {
        id: 2,
        name: "UrbanStitch",
        description: "UrbanStitch is your go-to destination...",
        state: "California",
        city: "Los Angeles",
        standard: {
            oneSide: "$20",
            doubleSide: "$40",
            additional: "$20",
        },
        premium: {
            oneSide: "$50",
            doubleSide: "$80",
            additional: "$20",
        },
    },
]


const dummyVendors = [
    {
        id: 1,
        name: "PremiumFit",
        description:
            "UrbanStitch is your go-to destination for stylish, high-quality t-shirts crafted with comfort and individuality in mind",
        state: "California",
        city: "Los Angeles",
        images: [
            "/standard-shirt1.png",
            "/standard-shirt2.png",
            "/premium-shirt1.png",
            "/premium-shirt2.png",
            "/premium-shirt3.png",
        ],
        standardPrice: {
            oneSide: "$20",
            doubleSide: "$40",
            additional: "$20",
            standardTag: "$25",
        },
        premiumPrice: {
            oneSide: "$50",
            doubleSide: "$80",
            additional: "$20",
            premiumTag: "$50",
        },
    },
]
const fabricOptions = [
    "Polyester",
    "Cotton",
    "Linen",
    "Organic Cotton",
    "Combed Cotton",
    "Modal",
    "Hemp",
    "Lycra",
    "Ringspun Cotton",
    "Nylon",
    "Rayon/Bamboo Viscose",
    "Poly",
    "Flannel",
    "Pima Cotton",
    "Bulk Cotton",
    "Spandex",
    "Sustainability",
    "Fleece Fabric",
]

const Merchants = () => {
    const navigate = useNavigate()
    const [selectedVendor, setSelectedVendor] = useState(null)
    const [selectedFabrics, setSelectedFabrics] = useState([])
    const [vendors, setVendors] = useState(dummyVendors)
    const [open, setOpen] = useState(false)
    const { control, handleSubmit, errors } = useForm();
    console.log(errors)
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [fabrics, setFabrics] = useState([])
    const handleFabricChange = (fabric) => {
        setSelectedFabrics((prev) => (prev.includes(fabric) ? prev.filter((f) => f !== fabric) : [...prev, fabric]))
    }
    useEffect(() => {
        console.log(selectedFabrics, 'selectedFabrics');
        getMerchants(selectedFabrics)

    }, [selectedFabrics])

    const handleFabricChange2 = (vendorId, fabricValue) => {
        setVendors((prev) =>
            prev.map((vendor) =>
                vendor._id === vendorId
                    ? { ...vendor, selectedFabric: fabricValue } // only update the clicked vendor
                    : vendor
            )
        );
        console.log(vendors, 'vendors');

    };
    const [selectedFabric, setSelectedFabric] = useState(""); // one state for both

    const handleChange = (event) => {
        setSelectedFabric(event.target.value);
    };

    const UpdateCart = async (vendor, fabric) => {





        try {
            let obj = {


                vendor_id: vendor?._id,
                fabric: fabric

            }

            const { message } = await OrderServices.UpdateCart(obj)


        } catch (error) {
            console.log(error);
        } finally {
            navigate("/checkout");
        }



    }

    const CustomPaper = (props) => (
        <Paper
            {...props}
            sx={{
                backgroundColor: "#101a33", // Navy blue background
                color: "white",
                borderRadius: "10px",
                mt: 1, // small margin top
            }}
        />
    );

    const getMerchants = async (fabrics) => {
        console.log(fabrics, 'fabrics');

        try {
            let obj = {
                state: localStorage.getItem('state'),
                city: localStorage.getItem('city'),
                fabrics: fabrics?.length > 0 ? fabrics.join(',') : ''
            }

            const { data } = await OrderServices.getMerchants(obj);
            console.log(data);
            const vendorsWithSelectedFabric = data?.vendors?.map((vendor) => ({
                ...vendor,
                selectedFabric:
                    vendor?.products?.[0]?.fabrics?.[0] ??
                    "", // fallback to empty string if no fabric exists
            }));

            setVendors(vendorsWithSelectedFabric);
            setSelectedFabric(data?.vendors[0]?.products[0]?.fabrics[0])

        } catch (error) {
            console.log(error);
        } finally {
        }
    };
    const getFabrics = async () => {


        try {
            let obj = {
                country: process.env?.REACT_APP_COUNTRY
            }

            const { data } = await OrderServices.getFabrics(obj);
            console.log(data);
            setFabrics(data?.fabrics)


        } catch (error) {
            console.log(error);
        } finally {
        }
    };
    console.log(errors);

    const onSubmit = (data) => {
        console.log("Form Data:", data);
        localStorage.setItem('state', data?.states?.emirate)
        localStorage.setItem('city', data?.cities?.emirate)
        getMerchants()
        setOpen(false);
    };

    const [selectedOption, setSelectedOption] = useState("");

    const handleChange2 = (event) => {
        setSelectedOption(event.target.value);
        console.log("Selected:", event.target.value);
    };

    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])
    const getStates = async (country) => {
        try {
            let params = { country: process.env?.REACT_APP_COUNTRY };
            const { data } = await OrderServices.getStates(params);
            console.log(data, 'countries');
            setStates(
                data?.states?.map((item, index) => ({
                    _id: index,
                    emirate: item
                }))
            );





        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    const getCities = async (value) => {
        console.log(value, 'value');

        try {
            let params = {
                country: process.env?.REACT_APP_COUNTRY,
                state: value?.emirate

            };
            const { data } = await OrderServices.getCities(params);
            console.log(data?.cities?.map((item, index) => ({
                _id: index,
                emirate: item
            })), 'cities');
            setCities(
                data?.cities?.map((item, index) => ({
                    _id: index,
                    emirate: item
                }))
            );




        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    useEffect(() => {
        getFabrics()
        getStates()
        getMerchants()
    }, [])

    return (
        <div>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="sm"
                slotProps={{
                    backdrop: {
                        sx: {
                            backdropFilter: "blur(8px)",
                        },
                    },
                }}
                PaperProps={{
                    sx: {
                        backgroundColor: "#0C1427",
                        boxShadow: "none",
                        borderRadius: '12px'
                    },
                }}
            >
                <DialogContent>

                    <Typography className='heading-font' variant="h4" sx={{ mb: 3, textAlign: 'center', fontWeight: 'bold' }}>
                        Select Delivery State & City
                    </Typography>
                    <Box
                        sx={{
                            backgroundColor: "#0C1427",
                            padding: "20px",
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                        component="form"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <Grid container spacing={2}>
                            {/* State Dropdown */}
                            <Grid item xs={12} sm={6} mt={2}>
                                <Controller
                                    name="states"
                                    control={control}
                                    rules={{ required: "State is required" }}
                                    render={({ field, fieldState }) => (
                                        <Autocomplete
                                            options={states || []}
                                            PaperComponent={CustomPaper}
                                            getOptionLabel={(option) => option?.emirate || ""}
                                            value={field.value || null}
                                            onChange={(e, newValue) => {
                                                field.onChange(newValue);
                                                getCities(newValue)
                                                setSelectedState(newValue);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="States"
                                                    error={!!fieldState.error}
                                                    helperText={fieldState.error?.message}
                                                    variant="outlined"
                                                    sx={{
                                                        input: { color: "white" },
                                                        label: { color: "white" },
                                                        ".MuiOutlinedInput-root": {
                                                            "& fieldset": { borderColor: "white", borderRadius: "15px" },
                                                            "&:hover fieldset": { borderColor: "white" },
                                                            "&.Mui-focused fieldset": { borderColor: "white" },
                                                            backgroundColor: "#101a33",
                                                        },
                                                    }}
                                                />
                                            )}
                                            renderOption={(props, option) => (
                                                <>
                                                    <li {...props} style={{ color: "white", backgroundColor: "#101a33" }}>
                                                        {option.emirate}
                                                    </li>
                                                    <Divider sx={{ backgroundColor: "white", opacity: 0.2 }} />
                                                </>
                                            )}
                                            sx={{
                                                "& .MuiSvgIcon-root": {
                                                    color: "white", // 👈 makes the dropdown arrow white
                                                },
                                                "& .MuiAutocomplete-listbox": { backgroundColor: "#101a33" },
                                                "& .MuiAutocomplete-option": { color: "white" },
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* City Dropdown */}
                            <Grid item xs={12} sm={6} mt={2}>
                                <Controller
                                    name="cities"
                                    control={control}
                                    rules={{ required: "City is required" }}
                                    render={({ field, fieldState }) => (
                                        <Autocomplete
                                            options={cities || []}
                                            PaperComponent={CustomPaper}
                                            getOptionLabel={(option) => option?.emirate || ""}
                                            value={field.value || null}
                                            onChange={(e, newValue) => {
                                                field.onChange(newValue);
                                                setSelectedCity(newValue);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="City"
                                                    error={!!fieldState.error}
                                                    helperText={fieldState.error?.message}
                                                    variant="outlined"
                                                    sx={{
                                                        input: { color: "white" },
                                                        label: { color: "white" },
                                                        ".MuiOutlinedInput-root": {
                                                            "& fieldset": { borderColor: "white", borderRadius: "15px" },
                                                            "&:hover fieldset": { borderColor: "white" },
                                                            "&.Mui-focused fieldset": { borderColor: "white" },
                                                            backgroundColor: "#101a33",
                                                        },
                                                    }}
                                                />
                                            )}
                                            renderOption={(props, option) => (
                                                <>
                                                    <li {...props} style={{ color: "white", backgroundColor: "#101a33" }}>
                                                        {option.emirate}
                                                    </li>
                                                    <Divider sx={{ backgroundColor: "white", opacity: 0.2 }} />
                                                </>
                                            )}
                                            sx={{
                                                "& .MuiSvgIcon-root": {
                                                    color: "white", // 👈 makes the dropdown arrow white
                                                },
                                                "& .MuiAutocomplete-listbox": { backgroundColor: "#101a33" },
                                                "& .MuiAutocomplete-option": { color: "white" },
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>

                        <Box mt={3}>
                            <SecondaryButton
                                p="15px 30px"
                                fontWeight="bold"
                                color="#0F172A"
                                sx={{
                                    background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)",
                                    borderRadius: "15px",
                                    border: "none",
                                }}
                                title="Submit"
                                type="submit"
                            />
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>

            <Box
                sx={{
                    backgroundImage: `url("${Images.contactBg}")`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "300px", // Adjust height as needed
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                    <Typography
                        variant="h3"
                        className="banner-text heading-font"
                        sx={{
                            fontSize: "35px",
                            textAlign: "center",
                            fontFamily: "Noto Sans, sans-serif",
                            color: "white",
                            fontWeight: "bold",
                        }}
                    >
                        Find PrintMeUp Merchants
                    </Typography>
                </Box>
            </Box>
            <Container maxWidth={"lg"} sx={{ my: 4 }}>

                <Grid container spacing={3}>
                 <Grid item xs={12} md={3}>
  <Box sx={{ bgcolor: "#0d1426", p: 2, borderRadius: '12px' }}>
    <Typography
      variant="h6"
      sx={{
        color: "#4fc3f7",
        mb: 2,
        fontWeight: "bold",
        fontFamily: "Maven Pro, sans-serif",
      }}
    >
      Fabric
    </Typography>

    <FormGroup
      sx={{
        display: { xs: "flex", md: "flex" },
        flexDirection: { xs: "row", sm: "column",md: "column",lg:'column' },
        overflowX: 'scroll',
        flexWrap:'nowrap',
        
        gap: { xs: 1, md: 0 },
        "&::-webkit-scrollbar": {
          height: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#4fc3f7",
          borderRadius: "10px",
        },
      }}
    >
      {fabrics.map((fabric) => (
        <FormControlLabel
          key={fabric}
          control={
            <Checkbox
              checked={selectedFabrics.includes(fabric)}
              onChange={() => handleFabricChange(fabric)}
              sx={{
                color: "white",
                "&.Mui-checked": { color: "#4fc3f7" },
              }}
            />
          }
          label={
            <Typography sx={{ color: "white", fontSize: "14px", whiteSpace: "nowrap", }}>
              {fabric}
            </Typography>
          }
        />
      ))}
    </FormGroup>
  </Box>
</Grid>

                    <Grid item xs={12} md={9}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", m: 1, mb: 3, }}>
                            <Typography variant="body2" sx={{ fontFamily: "Maven Pro, sans-serif", }} color="white">
                                Showing {vendors.length} results
                            </Typography>
                            <Box onClick={() => setOpen(true)} component={'div'}>
                                <Typography variant="body2" sx={{ cursor: 'pointer', fontFamily: "Maven Pro, sans-serif", }} color="white">
                                    <span className="heading-font" style={{ fontWeight: 'bold', fontFamily: "Maven Pro, sans-serif", }}> Location:</span> {localStorage.getItem('state')}, {localStorage.getItem('city')}
                                </Typography>
                            </Box>

                            {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography variant="body2">Sort by</Typography>
                        <select style={{ padding: "4px 8px", border: "1px solid #ccc", borderRadius: "4px" }}>
                            <option>Most Relevant</option>
                        </select>
                    </Box> */}
                        </Box>
                        <Grid container spacing={3}>
                            {vendors && vendors.length > 0 ? (
                                vendors.map((merchant) => (
                                    <Grid item xs={12} key={merchant?.id}>
                                        <Card
                                            sx={{
                                                bgcolor: "#192133",
                                                color: "white",
                                                borderRadius: "14px",
                                                p: 3,
                                                boxShadow: 3,
                                            }}
                                        >
                                            <Grid container spacing={2}>
                                                {/* LEFT SIDE (Info + Prices + Buttons) */}
                                                <Grid item xs={12} md={6}>
                                                    {/* Description */}
                                                    <Typography
                                                        variant="h4"
                                                        className="heading-font"
                                                        sx={{
                                                            mb: 2,
                                                            fontFamily: "Maven Pro, sans-serif",
                                                            fontWeight: "bold",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                            navigate("/merchant-detail", {
                                                                state: { merchant }, // passing data via state
                                                            })
                                                        }
                                                    >
                                                        {merchant?.name}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ mb: 2, mt: 2 }}>
                                                        <strong
                                                            style={{
                                                                fontFamily: "Maven Pro, sans-serif !important",
                                                                marginBottom: "20px",
                                                                fontSize: "16px",
                                                            }}
                                                        >
                                                            Description
                                                        </strong>
                                                        <br />
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ mb: 2, mt: 1.5 }}>
                                                        <span
                                                            style={{
                                                                fontSize: "14px",
                                                                fontFamily: "Maven Pro, sans-serif ",
                                                                marginTop: "25px",
                                                            }}
                                                        >
                                                            {merchant?.business_description}
                                                        </span>
                                                    </Typography>

                                                    {/* State + City */}
                                                    <Grid container spacing={0} sx={{ mb: 3, mt: 2 }}>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            sx={{
                                                                borderRight: { md: "1px solid rgba(255,255,255,0.2)", xs: '' },
                                                                pr: 2,
                                                            }}
                                                        >
                                                            <Typography variant="body2" sx={{ fontFamily: "Maven Pro, sans-serif " }}>
                                                                <strong>State</strong>
                                                            </Typography>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{ fontFamily: "Maven Pro, sans-serif ", mt: 1 }}
                                                            >
                                                                {merchant?.state}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12}
                                                            md={6} sx={{ pl: { md: 2, xs: 0 }, mt: { md: 0, xs: 1 } }}>
                                                            <Typography variant="body2" sx={{ fontFamily: "Maven Pro, sans-serif " }}>
                                                                <strong>City</strong>
                                                            </Typography>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{ fontFamily: "Maven Pro, sans-serif ", mt: 1 }}
                                                            >
                                                                {merchant?.city}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>

                                                    {/* Standard Prices */}
                                                    <Box sx={{ mb: 3 }}>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif " }}
                                                        >
                                                            <strong>Standard Prices</strong>
                                                        </Typography>
                                                        <Grid container>
                                                            <Grid item xs={4} sx={{ borderRight: "1px solid rgba(255,255,255,0.2)", pr: 2 }}>
                                                                <Typography variant="caption">One Side Print</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {merchant?.products?.length > 0 && merchant?.products[0]?.one_side_standard}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={4} sx={{ borderRight: "1px solid rgba(255,255,255,0.2)", px: 2 }}>
                                                                <Typography variant="caption">Double Side Print</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {merchant?.products?.length > 0 && merchant?.products[0]?.double_side_standard}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={4} sx={{ pl: 2 }}>
                                                                <Typography variant="caption">Additional Image</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {merchant?.products?.length > 0 && merchant?.products[0]?.additional_standard}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>

                                                    {/* Premium Prices */}
                                                    <Box sx={{ mb: 3 }}>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif " }}
                                                        >
                                                            <strong>Premium Prices</strong>
                                                        </Typography>
                                                        <Grid container>
                                                            <Grid item xs={4} sx={{ borderRight: "1px solid rgba(255,255,255,0.2)", pr: 2 }}>
                                                                <Typography variant="caption">One Side Print</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {merchant?.products?.length > 0 && merchant?.products[0]?.one_side_premium}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={4} sx={{ borderRight: "1px solid rgba(255,255,255,0.2)", px: 2 }}>
                                                                <Typography variant="caption">Double Side Print</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {merchant?.products?.length > 0 && merchant?.products[0]?.double_side_premium}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={4} sx={{ pl: 2 }}>
                                                                <Typography variant="caption">Additional Image</Typography>
                                                                <Typography variant="body2" mt={1.5}>
                                                                    {currencyType[process.env.REACT_APP_CURRENCY]?.code}{" "}
                                                                    {merchant?.products?.length > 0 && merchant?.products[0]?.additional_premium}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>

                                                    {/* Standard Fabrics */}
                                                    <Typography variant="body2" sx={{ mb: 1, fontFamily: "Maven Pro, sans-serif " }}>
                                                        <strong>Standard Fabrics</strong>
                                                    </Typography>

                                                    <>
                                                        <RadioGroup
                                                            row
                                                            value={merchant?.selectedFabric || ""}
                                                            onChange={(e) => handleFabricChange2(merchant?._id, e.target.value)}
                                                        >
                                                            <Grid container spacing={2}>
                                                                {merchant?.products?.length > 0 &&
                                                                    merchant?.products[0]?.fabrics?.map((fabric, index) => (
                                                                        <Grid item xs={4} key={index}>
                                                                            <FormControlLabel
                                                                                value={fabric?.name ?? fabric}
                                                                                control={
                                                                                    <Radio
                                                                                        sx={{
                                                                                            color: "white",
                                                                                            transform: "scale(0.9)",
                                                                                            padding: "2px",
                                                                                        }}
                                                                                    />
                                                                                }
                                                                                label={fabric?.name ?? fabric}
                                                                                sx={{
                                                                                    "& .MuiFormControlLabel-label": {
                                                                                        fontSize: "12px",
                                                                                        color: "white",
                                                                                    },
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    ))}
                                                            </Grid>
                                                        </RadioGroup>

                                                        {/* Premium Fabrics */}
                                                        {merchant?.products?.length > 0 &&
                                                            merchant?.products[0]?.premium_fabrics?.length > 0 && (
                                                                <>
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontFamily: "Maven Pro, sans-serif",
                                                                            mt: 2,
                                                                        }}
                                                                    >
                                                                        <strong>Premium Fabrics</strong>
                                                                    </Typography>

                                                                    <RadioGroup
                                                                        row
                                                                        value={merchant?.selectedFabric || ""}
                                                                        onChange={(e) => handleFabricChange2(merchant?._id, e.target.value)}
                                                                    >
                                                                        <Grid container spacing={2}>
                                                                            {merchant?.products[0]?.premium_fabrics?.map((fabric, index) => (
                                                                                <Grid item xs={4} key={index}>
                                                                                    <FormControlLabel
                                                                                        value={fabric?.name ?? fabric}
                                                                                        control={
                                                                                            <Radio
                                                                                                sx={{
                                                                                                    color: "white",
                                                                                                    transform: "scale(0.9)",
                                                                                                    padding: "2px",
                                                                                                }}
                                                                                            />
                                                                                        }
                                                                                        label={fabric?.name ?? fabric}
                                                                                        sx={{
                                                                                            "& .MuiFormControlLabel-label": {
                                                                                                fontSize: "12px",
                                                                                                color: "white",
                                                                                            },
                                                                                        }}
                                                                                    />
                                                                                </Grid>
                                                                            ))}
                                                                        </Grid>
                                                                    </RadioGroup>
                                                                </>
                                                            )}
                                                    </>

                                                    {/* Buttons */}
                                                    <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            onClick={() => {
                                                                console.log('asdasdas');

                                                                setSelectedVendor(merchant);
                                                                localStorage.setItem("merchant", JSON.stringify(merchant));
                                                                UpdateCart(merchant, merchant?.selectedFabric)

                                                            }}
                                                            sx={{
                                                                bgcolor: "transparent",
                                                                border: "1px solid #0BD1D1",
                                                                color: "#0BD1D1",
                                                                fontWeight: 700,
                                                                flex: 1,
                                                                fontFamily: "Maven Pro, sans-serif",
                                                                textTransform: "capitalize",
                                                                borderRadius: "12px",
                                                                padding: "6px 16px",
                                                            }}
                                                        >
                                                            Place Order
                                                        </Button>
                                                    </Box>
                                                </Grid>

                                                {/* RIGHT SIDE (Images) */}
                                                <Grid item xs={12} md={6} mt={2}>
                                                    <Grid container justifyContent={"center"} spacing={2}>
                                                        <Grid item xs={10}>
                                                            <Box
                                                                sx={{
                                                                    mb: 2,
                                                                    position: "relative",
                                                                    borderRadius: "12px",
                                                                    overflow: "hidden",
                                                                    "&:hover .overlayNew": {
                                                                        opacity: 1,
                                                                    },
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <CardMedia
                                                                    component="img"
                                                                    height="350"
                                                                    image={
                                                                        merchant?.products?.length > 0 &&
                                                                        merchant?.products[0]?.sample_images[0]
                                                                    }
                                                                    alt="Main"
                                                                    sx={{
                                                                        borderRadius: "12px",
                                                                        objectFit: "cover",
                                                                    }}
                                                                />
                                                                <Box
                                                                    className="overlayNew"
                                                                    sx={{
                                                                        position: "absolute",
                                                                        inset: 0,
                                                                        bgcolor: "rgba(0,0,0,0.5)",
                                                                        backdropFilter: "blur(6px)",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        opacity: 0,
                                                                        transition: "opacity 0.3s ease",
                                                                        borderRadius: "12px",
                                                                    }}
                                                                >
                                                                    <Button
                                                                        onClick={() =>
                                                                            navigate("/merchant-detail", {
                                                                                state: { merchant },
                                                                            })
                                                                        }
                                                                        variant="contained"
                                                                        sx={{
                                                                            bgcolor: "#fff",
                                                                            color: "#000",
                                                                            textTransform: "none",
                                                                            fontWeight: "bold",
                                                                            borderRadius: "8px",
                                                                            px: 2,
                                                                            py: 1,
                                                                            "&:hover": {
                                                                                bgcolor: "#f0f0f0",
                                                                            },
                                                                        }}
                                                                    >
                                                                        View More
                                                                    </Button>
                                                                </Box>
                                                            </Box>

                                                            <Grid container spacing={2}>
                                                                {merchant?.products?.length > 0 &&
                                                                    merchant?.products[0]?.sample_images
                                                                        ?.slice(1, 3)
                                                                        .map((img, index) => (
                                                                            <Grid item xs={6} key={index}>
                                                                                <Box
                                                                                    sx={{
                                                                                        position: "relative",
                                                                                        borderRadius: "12px",
                                                                                        overflow: "hidden",
                                                                                        "&:hover .overlay": {
                                                                                            opacity: 1,
                                                                                        },
                                                                                    }}
                                                                                >
                                                                                    <CardMedia
                                                                                        component="img"
                                                                                        height="130"
                                                                                        image={img}
                                                                                        alt={`extra-${index}`}
                                                                                        sx={{
                                                                                            borderRadius: "12px",
                                                                                            objectFit: "cover",
                                                                                        }}
                                                                                    />
                                                                                    <Box
                                                                                        className="overlay"
                                                                                        sx={{
                                                                                            position: "absolute",
                                                                                            inset: 0,
                                                                                            bgcolor: "rgba(0,0,0,0.5)",
                                                                                            backdropFilter: "blur(6px)",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            justifyContent: "center",
                                                                                            opacity: 0,
                                                                                            transition: "opacity 0.3s ease",
                                                                                            borderRadius: "12px",
                                                                                        }}
                                                                                    >
                                                                                        <Button
                                                                                            onClick={() =>
                                                                                                navigate("/merchant-detail", {
                                                                                                    state: { merchant },
                                                                                                })
                                                                                            }
                                                                                            variant="contained"
                                                                                            sx={{
                                                                                                bgcolor: "#fff",
                                                                                                color: "#000",
                                                                                                textTransform: "none",
                                                                                                fontWeight: "bold",
                                                                                                borderRadius: "8px",
                                                                                                px: 2,
                                                                                                py: 1,
                                                                                                "&:hover": {
                                                                                                    bgcolor: "#f0f0f0",
                                                                                                },
                                                                                            }}
                                                                                        >
                                                                                            View More
                                                                                        </Button>
                                                                                    </Box>
                                                                                </Box>
                                                                            </Grid>
                                                                        ))}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                ))
                            ) : (
                                <Grid item xs={12}>
                                    <Box
                                        sx={{
                                            height: "60vh",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            bgcolor: "#192133",
                                            borderRadius: "14px",
                                            color: "white",
                                            boxShadow: 3,
                                        }}
                                    >
                                        <Typography
                                            variant="h4"
                                            sx={{
                                                fontFamily: "Maven Pro, sans-serif",
                                                fontWeight: "bold",
                                                color: "#0BD1D1",
                                                mb: 1,
                                            }}
                                        >
                                            No Vendors Found
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontFamily: "Maven Pro, sans-serif",
                                                color: "rgba(255,255,255,0.7)",
                                            }}
                                        >
                                            Please try again later or adjust your filters.
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>



                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default Merchants
